import { Chip, Stack, SxProps, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlPlannerShiftCompletionStatus } from "~/__generated__/graphql/types";

type Props = {
    value: GqlPlannerShiftCompletionStatus | undefined;
    onChange: (value: GqlPlannerShiftCompletionStatus | undefined) => void;
    sx?: SxProps<Theme>;
};

export default function PlannerShiftCompletionStatusSelect({ value, onChange, sx }: Props) {
    const { t } = useTranslation("shared");

    const options = Object.values(GqlPlannerShiftCompletionStatus);

    return (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={sx}>
            {options.map(status => {
                const selected = status === value;
                return (
                    <Chip
                        key={status}
                        label={t(`PlannerShiftCompletionStatusSelect.${status}`)}
                        variant={selected ? "filled" : "outlined"}
                        color={selected ? "primary" : "default"}
                        onClick={() => onChange(selected ? undefined : status)}
                    />
                );
            })}
        </Stack>
    );
}
